import * as React from 'react';
import { translate } from '@js/common/helpers';
var SearchBar = function (_a) {
    var onChange = _a.onChange;
    var handleChange = function (event) {
        var input = event.target.value;
        if (input.length > 0 && input.length < 3) {
            return;
        }
        onChange(input);
    };
    return (React.createElement("div", { className: "tagbook--search-bar" },
        React.createElement("input", { type: "text", placeholder: translate('tagbook.search'), onChange: handleChange })));
};
export { SearchBar };
